import { useSearchParams } from 'react-router-dom';
import { Logo } from '../components/ui';

const ERRORS: Record<string, string> = {
  dominio_nao_permitido:
    'Essa conta não pertence ao domínio da empresa. Use o seu e-mail corporativo.',
  nao_cadastrado: 'Seu e-mail ainda não foi liberado. Fale com o administrador.',
  usuario_inativo: 'Este acesso foi desativado.',
  acesso_negado: 'Login cancelado.',
  sessao_expirada: 'A tentativa de login expirou. Tente novamente.',
  state_invalido: 'Não foi possível validar o login. Tente novamente.',
  sem_codigo: 'O Google não retornou a autorização. Tente novamente.',
};

export function LoginPage() {
  const [params] = useSearchParams();
  const error = params.get('error');

  return (
    <div className="login">
      <div className="login__card">
        <div style={{ marginBottom: 22 }}>
          <Logo variant="stacked" height={64} />
        </div>
        <h1>Controle de horas</h1>
        <p>Entre com a sua conta do Google da empresa.</p>

        {error ? (
          <div
            role="alert"
            style={{
              background: 'var(--danger-bg)',
              color: 'var(--danger)',
              borderRadius: 'var(--r-md)',
              padding: '10px 14px',
              fontSize: '0.88rem',
              fontWeight: 600,
              marginBottom: 18,
              textAlign: 'left',
            }}
          >
            {ERRORS[error] ?? 'Não foi possível entrar. Tente novamente.'}
          </div>
        ) : null}

        {/* link real, não fetch: o fluxo OAuth precisa de navegação de topo */}
        <a className="btn btn--google" href="/api/auth/google">
          <svg width="18" height="18" viewBox="0 0 24 24" aria-hidden="true">
            <path
              fill="#4285F4"
              d="M23.5 12.3c0-.8-.1-1.6-.2-2.3H12v4.5h6.5a5.6 5.6 0 0 1-2.4 3.7v3h3.9c2.3-2.1 3.5-5.2 3.5-8.9z"
            />
            <path
              fill="#34A853"
              d="M12 24c3.2 0 5.9-1.1 7.9-2.9l-3.9-3c-1.1.7-2.4 1.2-4 1.2-3.1 0-5.7-2.1-6.6-4.9H1.4v3.1A12 12 0 0 0 12 24z"
            />
            <path fill="#FBBC05" d="M5.4 14.4a7.2 7.2 0 0 1 0-4.6V6.7H1.4a12 12 0 0 0 0 10.8l4-3.1z" />
            <path
              fill="#EA4335"
              d="M12 4.8c1.8 0 3.3.6 4.6 1.8l3.4-3.4C17.9 1.2 15.2 0 12 0 7.3 0 3.3 2.7 1.4 6.7l4 3.1C6.3 6.9 8.9 4.8 12 4.8z"
            />
          </svg>
          Entrar com Google
        </a>

        <div className="login__foot">
          Todo acesso e lançamento fica registrado para fins de auditoria.
        </div>
      </div>
    </div>
  );
}
